import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteData } from '../data/mock';

const Layout = ({ children }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/approach', label: 'Approach' },
    { path: '/engagements', label: 'Engagements' },
    { path: '/infrastructure', label: 'Infrastructure' },
    { path: '/perspective', label: 'Perspective' }
  ];
  
  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <header className="border-b border-[#E8E8E6]">
        <div className="w-full max-w-3xl mx-auto px-5 sm:px-6 py-6 sm:py-8">
          <nav className="flex items-center justify-between">
            <Link 
              to="/" 
              className="text-[#1a1a1a] text-base sm:text-lg tracking-tight font-medium"
            >
              {siteData.siteName}
            </Link>
            
            {/* Mobile menu button */}
            <button 
              className="sm:hidden text-[#1a1a1a] p-1"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span className="text-sm tracking-wide">{menuOpen ? 'Close' : 'Menu'}</span>
            </button>
            
            {/* Desktop navigation */}
            <div className="hidden sm:flex gap-6 lg:gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm tracking-wide transition-opacity ${
                    location.pathname === link.path
                      ? 'text-[#1a1a1a]'
                      : 'text-[#666666] hover:text-[#1a1a1a]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </nav>
          
          {/* Mobile navigation */}
          {menuOpen && (
            <div className="sm:hidden pt-6 pb-2 border-t border-[#E8E8E6] mt-6">
              <div className="flex flex-col space-y-4">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setMenuOpen(false)}
                    className={`text-base tracking-wide ${
                      location.pathname === link.path
                        ? 'text-[#1a1a1a]'
                        : 'text-[#666666]'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>
      
      <main className="w-full max-w-3xl mx-auto px-5 sm:px-6 py-12 sm:py-20 lg:py-24">
        {children}
      </main>
      
      <footer className="border-t border-[#E8E8E6]">
        <div className="w-full max-w-3xl mx-auto px-5 sm:px-6 py-6 sm:py-8">
          <p className="text-sm text-[#999999]">
            {siteData.siteName}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
